import RepairsBoard from './RepairsBoard';

export default function RepairsPage() {
  return <RepairsBoard />;
}
